export default {
  menu: 'Inventory',
  title: 'Inventory',
  dynamicTitle: '{name} Inventory',

  tabs: {
    inventory: 'Inventory',
    turnover: 'Product warehouse turnover'
  },

  table: {
    header: {
      rowNumber: 'Row',
      image: 'Photo',
      barcode: 'Barcode',
      code: 'Code',
      category: 'Category',
      name: 'Title',
      variant: 'Variable',
      openingInventory: 'First Course',
      received: 'Reached warehouse',
      minInventory: 'Minimum Inventory',
      totalInventory: 'Total inventory',
      sent: 'Posted',
      onWay: 'On the way',
      waitingToSend: 'Waiting to send',
      saleInventory: 'Inventory for sale'
    }
  },

  notifications: {
    export: {
      success: 'The request to get the output of browsing some warehouses has been successfully completed, please wait.',
      error: 'The request to receive the output of a number of warehouses was accompanied by an error.'
    }
  }
}
